export const convertToEmojis = (number) => {
  const emojis = ["0️⃣", "1️⃣", "2️⃣", "3️⃣", "4️⃣", "5️⃣", "6️⃣", "7️⃣", "8️⃣", "9️⃣"];
  const digits = number.toString().split("");
  let result = "";
  digits.forEach((digit) => {
    result += emojis[digit];
  });
  return result;
};
